<template lang="html">
  <section class="wrapper-menu">
    <section class="wrapper ahora-contigo padding-menu">
      <slick
        class="slider-part-historia slider-galeria"
        ref="slick-slide-2"
        :options="slickOptions"
      >
        <template>
          <a href="https://www.youtube.com/watch?v=EGn7AI_W7Jo" target="_blank">
            <video
              class="video"
              controls
              autoplay
              playsinline
              loop
              preload="metadata"
              muted
            >
              <source src="/static/img/risiGusanitos.webm" type="video/webm" />
            </video>
          </a>
          <a :href="'/' + $i18n.locale + '/' + $t('enlaces.jummy')">
            <div class="row-center bannerhome-imagen">
              <img :src="'/static/img/banner-home/jummy-' +
                $i18n.locale +
                '.jpg'" />
            </div>
          </a>
          <a href="https://risketosxtroncos.com" target="_blank">
            <div class="row-center bannerhome-imagen">
              <img
                :src="
                  '/static/img/banner-home/risketos-troncos-' +
                    $i18n.locale +
                    '.jpg'
                "
              />
            </div>
          </a>
           <a href="https://www.youtube.com/watch?v=CY-SkNnQvhw" target="_blank">
            <div class="row-center bannerhome-imagen">
              <img
                :src="
                  '/static/img/banner-home/palomitas-' +
                    $i18n.locale +
                    '.jpg'
                "
              />
            </div>
          </a>
        </template>
      </slick>
    </section>

    <!-- 
    <div class="contenedor-video">
      <video  class="video" autoplay muted="muted" playsinline loop>
        <source src="/static/img/video-risketos.mp4" type="video/mp4">
      </video>

      <a class="btn -action" href="https://vamoscontodorisi.com/" target="_blank">¡PARTICIPA!</span></a>
    </div> -->

    <modulo-snacks></modulo-snacks>
    <modulo-galletas></modulo-galletas>
    <modulo-caramelos></modulo-caramelos>
    <modulo-frutos-secos></modulo-frutos-secos>
    <modulo-patatas></modulo-patatas>

    <banner-historia id="historia"></banner-historia>
    <modulo-noticias></modulo-noticias>
    <modulo-newsletter></modulo-newsletter>
    <!-- <section class="banner-placersofia">
      <div class="container row-start">
        <div class="contenedor-productos">
          <img
            :src="'/static/img/tit-placerosofia-' + $i18n.locale + '.png'"
            alt="Placesofia by Mios"
            class="titulo"
          />
          <img
            src="/static/img/maiz-y-chia.png"
            alt="Maíz y Chia"
            class="chia"
          />
          <img
            src="/static/img/maiz-y-cebolla.png"
            alt="Maíz y cebolla"
            class="cebolla"
          />
          <img
            src="/static/img/maiz-y-espinaca.png"
            alt="Maíz y Espinaca"
            class="espinaca"
          />
        </div>
      </div>
    </section> -->
    <banner-promociones></banner-promociones>
  </section>
</template>

<script lang="js">
  import Slick from 'vue-slick';

  import bannerHistoria from '@/components/view-parts/historia/banner-historia';

  import moduloSnacks from '@/components/views/home/modulo-snacks';
  import moduloGalletas from '@/components/views/home/modulo-galletas';
  import moduloCaramelos from '@/components/views/home/modulo-caramelos';
  import moduloFrutosSecos from '@/components/views/home/modulo-frutos-secos';
  import moduloPatatas from '@/components/views/home/modulo-patatas';
  import moduloNoticias from '@/components/views/home/modulo-noticias';
  import bannerPromociones from '@/components/parts/banner-promociones';
  import moduloNewsletter from '@/components/views/home/modulo-newsletter';

  export default {
    name: 'home',
    components: {
      'banner-historia': bannerHistoria,
      'modulo-snacks': moduloSnacks,
      'modulo-galletas': moduloGalletas,
      'modulo-caramelos': moduloCaramelos,
      'modulo-frutos-secos': moduloFrutosSecos,
      'modulo-patatas': moduloPatatas,
      'modulo-noticias': moduloNoticias,
      'banner-promociones': bannerPromociones,
      'modulo-newsletter': moduloNewsletter,
      Slick

    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          initialSlide: 0,
          autoplay: true,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: true,

          arrows: true,

          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        },
      }
    },
    methods: {

    }

  }
</script>

<style scoped>
.contenedor-video {
  position: relative;
}

.slick-slide img,
.slick-slide video {
  display: block;
  height: 100%;
  width: 100%;
  max-height: 90vh;
  object-fit: cover;
  object-position: center center;
}

.contenedor-video .btn {
  position: absolute;
  right: 100px;
  bottom: 50px;
  color: #44137f;
}

.contigo-container {
  width: 100%;
  padding: 810px 325px;
  background: url(/static/img/banner-home/koala1.jpg);
  background-size: cover;
  background-repeat: no-repeat;
}

.koala {
  background: url(/static/img/banner-home/koala2.jpg);
  background-size: cover;
  background-repeat: no-repeat;
}

.video {
  width: 100%;
  height: auto;
  display: block;
}

.video-movil {
  width: 100%;
  display: none;
}

@media screen and (max-width: 2500px) {
  .contigo-container {
    padding: 714px 156px;
  }
}

@media screen and (max-width: 2125px) {
  .contigo-container {
    padding: 599px 325px;
  }
}

@media screen and (max-width: 2175px) {
  .contigo-container {
    padding: 522px 0px;
  }
}

@media screen and (max-width: 1880px) {
  .contigo-container {
    padding: 476px 325px;
  }
}

@media screen and (max-width: 1700px) {
  .contigo-container {
    padding: 431px 325px;
  }
}

@media screen and (max-width: 1500px) {
  .contigo-container {
    padding: 436px 325px;
  }
}

@media screen and (min-width: 1500px) {
  .contenedor-video {
    display: block;
    width: 100%;
    overflow: hidden;
  }
}

@media screen and (max-width: 1482px) {
  .contigo-container {
    padding: 414px 325px;
  }
}

@media screen and (max-width: 1390px) {
  .contigo-container {
    padding: 353px 305px;
  }
}

@media screen and (max-width: 1130px) {
  .contigo-container {
    padding: 280px 305px;
  }
}

@media screen and (max-width: 959px) {
  .contigo-container {
    padding: 257px 305px;
  }

  [route="home"] .wrapper.ahora-contigo .btn,
  [route="snacks"] .wrapper.ahora-contigo .btn {
    position: absolute;
    right: 60px;
    bottom: 20px;
    z-index: 4;
  }
}

@media screen and (max-width: 895px) {
  .contigo-container {
    padding: 239px 305px;
  }
}

@media screen and (max-width: 820px) {
  .contigo-container {
    padding: 223px 305px;
  }
}

@media screen and (max-width: 800px) {
  .contigo-container {
    padding: 208px 305px;
  }
}

@media screen and (max-width: 720px) {
  .contigo-container {
    padding: 184px 305px;
  }
}

@media screen and (max-width: 650px) {
  .contigo-container {
    padding: 175px 271px;
  }
}

@media screen and (max-width: 610px) {
  .contigo-container {
    padding: 163px 271px;
  }
}

@media screen and (max-width: 565px) {
  .btn.-action {
    height: 60px;
    line-height: 60px;
    font-size: 20px;
  }

  [route="home"] .wrapper.ahora-contigo .btn,
  [route="snacks"] .wrapper.ahora-contigo .btn {
    position: absolute;
    right: 30px;
    bottom: 20px;
    z-index: 4;
  }

  .contigo-container {
    padding: 150px 261px;
  }
}

@media screen and (max-width: 515px) {
  .contigo-container {
    padding: 140px 179px;
  }
}

@media screen and (max-width: 490px) {
  .contigo-container {
    padding: 125px 179px;
  }
}

@media screen and (max-width: 435px) {
  .contigo-container {
    padding: 121px 178px;
  }

  .btn.-action {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
  }
}

@media screen and (max-width: 420px) {
  .contigo-container {
    padding: 113px 178px;
  }
}

@media screen and (max-width: 400px) {
  .contigo-container {
    padding: 105px 178px;
  }
}

@media screen and (max-width: 290px) {
  .contigo-container {
    padding: 80px 0px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue